import React, { useState,} from 'react';

import './Estimate.css';
import Form from '../Form/Form';
import Result from '../Result/Result';
import { validator } from './Util/Validator';

export default function Estimate() {

  const [student,setStudent] = useState({})
  const [house_meal, setHouseMeal] = useState({})
  const [finance, setFinance] = useState({})
  const [additional, setAdditional] = useState([])
  const [invalid, setInvalid] = useState([])
  const [form, setForm] = useState(true)

  const changeState = (section, newState) => {
    switch (section) {
      case 'student':
        setStudent(newState)
        break
      case 'house_meal':
        setHouseMeal(newState)
        break
      case 'finance':
        setFinance(newState)
        break
      case 'additional':
        setAdditional(newState)
        break
      default:
        break
    }
  }
  const valid = () => {
    const ans = validator({ student, house_meal, finance, additional })
    setInvalid(ans)
    return ans.length===0
  }

  return (
    <div className="estimator">
      {
        form ? 
        <Form data={{ student, house_meal, finance, additional }} 
          invalid={invalid}
          changeState={changeState} 
          onSubmit={() => (valid()) ? setForm(false) : null} />
        : 
        <Result data={{ student, house_meal, finance, additional }} 
          invalid={invalid}
          changeState={changeState} 
          onPrev={() => setForm(true)} 
          onRestart={() => { setForm(true); setStudent({}); setHouseMeal({}); setFinance({}); setAdditional([]); }} />
      }
    </div>
  )
}

